// types
import type { FeatureDiscoveryOrganismStep } from '@sdb/planning-ui/ui-3/packages/types/src/components/organisms/FeatureDiscovery.types';

// utils
import { createStepsUtil } from '@sdb/planning-ui';
import { Trans } from 'react-i18next';

export const Steps = [
  {
    id: 'start',
    selector: () => null,
    title: <Trans i18nKey="flexMatch.featureTour.step1.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step1.description" />
  },
  {
    id: 'newRequest',
    selector: () =>
      document.querySelector("[data-tourid='flex-match-new-request']"),
    title: <Trans i18nKey="flexMatch.featureTour.step2.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step2.description" />
  },
  {
    id: 'bulkActions',
    selector: () =>
      document.querySelector("[data-tourid='flex-match-bulk-actions']"),
    title: <Trans i18nKey="flexMatch.featureTour.step6.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step6.description" />
  },
  {
    id: 'filters',
    selector: () => document.querySelector("[data-tourid='flex-match-filter']"),
    title: <Trans i18nKey="flexMatch.featureTour.step4.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step4.description" />
  },
  {
    id: 'viewMode',
    selector: () =>
      document.querySelector("[data-tourid='flex-match-view-mode']"),
    title: <Trans i18nKey="flexMatch.featureTour.step5.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step5.description" />
  },
  {
    id: 'dateNavigation',
    selector: () =>
      document.querySelector("[data-tourid='flex-match-date-navigation']"),
    title: <Trans i18nKey="flexMatch.featureTour.step3.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step3.description" />
  },
  {
    id: 'costCentersCell',
    selector: () =>
      document.querySelector(".MuiDataGrid-cell[data-field='costCenterName']"),
    title: <Trans i18nKey="flexMatch.featureTour.step7.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step7.description" />
  },
  {
    id: 'tableActions',
    selector: () =>
      document.querySelector(".MuiDataGrid-cell[data-field='actions']"),
    title: <Trans i18nKey="flexMatch.featureTour.step8.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step8.description" />,
    offset: { x: 35 }
  },
  {
    id: 'ending',
    selector: () => null,
    title: <Trans i18nKey="flexMatch.featureTour.step9.title" />,
    description: <Trans i18nKey="flexMatch.featureTour.step9.description" />
  }
] as const satisfies FeatureDiscoveryOrganismStep[];

export const FlexMatchSteps = createStepsUtil(Steps);
